import { ApiService } from '@/api';
import { Badge } from '@/models';
import { BadgesCount, GeekProfileBadge } from '@/models/geek-profile';

export class BadgesApi {
  private readonly geeksBaseUrl = '/api/geeks';
  private readonly badgesBaseUrl = '/api/badges';

  public async fetchBadges(): Promise<Badge[]> {
    const response = await ApiService.get(`${this.badgesBaseUrl}`);

    return response.json();
  }

  public async fetchGeekBadgesCount(geekId: string): Promise<BadgesCount> {
    const response = await ApiService.get(`${this.geeksBaseUrl}/${geekId}/badges-count`);

    return response.json();
  }

  public async fetchGeekBadges(geekId: string): Promise<GeekProfileBadge[]> {
    const response = await ApiService.get(`${this.geeksBaseUrl}/${geekId}/badges`);

    return response.json();
  }

}
